import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThymeleafComponent } from './simple-icons-thymeleaf.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThymeleafComponent ],
    exports:      [ SimpleIconsThymeleafComponent ],
    bootstrap:    []
})
export class SimpleIconsThymeleafModule {}
